import React from 'react'

function Sensor() {
  return (
    <div>Sensor</div>
  )
}

export default Sensor